import { ModelInModelTreeInProcessEditor } from "../create-model-tree-for-porcess-editor-and-set-uuid/create-model-tree-for-porcess-editor-and-set-uuid";

export const getModelFromModelTreeInPorcessEditorByUUID = (uuid: string, modelTree: ModelInModelTreeInProcessEditor[]): ModelInModelTreeInProcessEditor | undefined => {
    for (const model of modelTree) {
        if (model.uuid === uuid) return model;
        else {
            if (model.children && model.children.length > 0) {
                const _model = getModelFromModelTreeInPorcessEditorByUUID(uuid, model.children);
                if (_model) return _model;
            }
        }
    }

    return undefined;
};